/*
  Static reviews keen-slider carousel — extracted from sections/reviews-static.liquid so it ships from a cacheable, deferred asset
  instead of inline markup. Still DOMContentLoaded-gated and guarded by .ks-initialized, so multiple instances stay safe.
*/

document.addEventListener("DOMContentLoaded", () => {
  const reviewSlider = document.getElementById("static-reviews-slider");
  const toggleBtn = reviewSlider ? reviewSlider.closest(".static-reviews-container")?.querySelector(".nav-toggle"): null;
  if (!reviewSlider || reviewSlider.classList.contains("ks-initialized")) return;

  let mainSlider;

  // init keen slider
  mainSlider = new KeenSlider(
    reviewSlider,
    {
      loop: true,
      slides: { perView: 3.2, spacing: 16 },
      renderMode: "performance",
      breakpoints: {
        "(max-width: 900px)": { slides: { perView: 1.1, spacing: 16 } }
      },
      created: () => { updateDivHeights && updateDivHeights(); },
      slideChanged: () => { updateDivHeights && updateDivHeights(); },
      resize: () => { updateDivHeights && updateDivHeights(); }
    },
    [
      autoplayPlugin({ interval: 4000, toggleButton: toggleBtn })
    ]
  );

  // autoplay plugin with play/pause button
  function autoplayPlugin({ interval = 3000, toggleButton } = {}) {
    return (slider) => {
      let timeoutId;
      let playing = true;
      let onToggleClick;

      function clearTimer() {
        if (timeoutId) {
          clearTimeout(timeoutId);
          timeoutId = undefined;
        }
      }

      function queueNext() {
        clearTimer();
        if (!playing) return;
        timeoutId = setTimeout(() => slider.next(), interval);
      }

      function updateButton() {
        if (!toggleButton) return;
        toggleButton.dataset.state = playing ? "playing" : "paused";
        toggleButton.setAttribute("aria-pressed", playing ? "true" : "false");
        toggleButton.setAttribute("aria-label", playing ? "Pause slideshow" : "Play slideshow");
      }

      function play() { if (!playing) { playing = true; updateButton(); queueNext(); } }
      function pause() { if (playing) { playing = false; updateButton(); clearTimer(); } }

      slider.on("created", () => {
        updateButton();
        queueNext();
        if (toggleButton) {
          onToggleClick = () => (playing ? pause() : play());
          toggleButton.addEventListener("click", onToggleClick);
        }
      });

      slider.on("dragStarted", clearTimer);
      slider.on("animationEnded", queueNext);
      slider.on("updated", queueNext);

      slider.on("destroyed", () => {
        clearTimer();
        if (toggleButton && onToggleClick) toggleButton.removeEventListener("click", onToggleClick);
      });

      slider.autoplay = { play, pause, isPlaying: () => playing };
    };
  }

  // arrows drive the slider
  document.querySelectorAll(".nav-prev").forEach((btn) => {
    btn.addEventListener("click", (e) => { e.preventDefault(); if (mainSlider) mainSlider.prev(); });
  });
  document.querySelectorAll(".nav-next").forEach((btn) => {
    btn.addEventListener("click", (e) => { e.preventDefault(); if (mainSlider) mainSlider.next(); });
  });
});
